import { isNumber } from "@bonusmap/shared_ui/library";
import { BaseWebComponent } from "../base-components/base-web-component";
import { ProfileAdditionalDataComponentInput } from "./profile-additional-data-component.js";
import { ProfileAdditionalDataRecord, profileAdditionalDataSchemaRecord } from "@bonusmap/api-types";

export class ProfileAdditionalDataItem extends BaseWebComponent {
    static webComponentName: string = "profile-additional-data-item";
    static observedAttributes = []; // Nessun attributo da osservare per ora
    protected _templateId: string = "profile-additional-data-item";
    protected additionalDataControl!: ProfileAdditionalDataComponentInput;
    protected inputValueEl!: HTMLTextAreaElement;
    constructor() {
        super();
        this.globalEventListeners();
    }
    private _additionalDataValue!: string;
    public get additionalDataValue(): string {
        if (!this._additionalDataValue) {
            this._additionalDataValue = this.attributeStringOption('additional-data-value', '');
        }
        return this._additionalDataValue;
    }
    public set additionalDataValue(value: string) {
        this._additionalDataValue = value;
    }
    private _additionalDataId!: number;
    public get additionalDataId(): number {
        if (!this._additionalDataId) {
            this._additionalDataId = this.attributeNumberOption('additional-data-id', 0);
        }
        return this._additionalDataId;
    }
    public set additionalDataId(value: number) {
        const changed = this._additionalDataId !== value;
        if (isNumber(value) && value > 0) {
            this._additionalDataId = value;
        }
        if (changed) {
            // [debug] console.log("additional data id changed, re-rendering");
            this.render();
        }
    }
    public get value(): ProfileAdditionalDataRecord {
        const v = {
            additional_id: this.additionalDataId,
            value: this.additionalDataValue
        };
        if (profileAdditionalDataSchemaRecord.safeParse(v).success) {
            return v;
        }
        return null;
    }

    private globalEventListeners() {
        this.addEventListener('profile-additional-data-step', (event: Event) => {
            const { step } = (event as CustomEvent).detail;
            event.stopPropagation(); // Prevent event from bubbling up
            this.classList.toggle('d-edit', step !== 'additionals-view');

        });

    }
    protected afterRender(): void {
        super.afterRender();
        this.additionalDataControl = this.querySelector('profile-additional-data-input') as ProfileAdditionalDataComponentInput;
        if (this.additionalDataControl) {
            this.additionalDataControl.addEventListener('value-changed', (event: Event) => {
                event.stopPropagation(); // Prevent event from bubbling up
                const dataId = (event.target as ProfileAdditionalDataComponentInput).value;
                if (isNumber(dataId)) {
                    this.additionalDataId = parseInt(dataId);
                }
                this.dispatch('value-item-changed', { origin: this });

            });
        }

        this.inputValueEl = this.querySelector('textarea[name="inputValue"]') as HTMLTextAreaElement;
        if (this.inputValueEl) {
            this.inputValueEl.addEventListener('input', (event: Event) => {
                event.stopPropagation(); // Prevent event from bubbling up
                this.additionalDataValue = this.inputValueEl.value;
                // [debug] console.log("input value changed", this.additionalDataValue);
                this.dispatch('value-item-changed', { origin: this });
            });
        }
    }
    protected buildRenderingData(): Record<string, any> {
        const data = super.buildRenderingData();
        return {
            ...data,
            additionalDataId: this.additionalDataId,
            additionalDataValue: this.additionalDataValue
        }
    }
}